import styled, { css } from 'styled-components';
import FontGraphie from '../../../components/loggedout/shared-styles/graphieFont';
import { DisplacementTransition } from '../../../components/loggedout/shared-styles/transitions';
import * as C from '../../../components/loggedout/shared-styles/Colors';
import { device } from '../../../utils/responsive_utilities';

export const SplashverseOnboardingContainer = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  ${(props) => !props.isProductPage ? css`
    height: calc(100% - 11.4rem);
    overflow: ${(props) => props.scroll? 'scroll':'hidden'};
    padding-top: 5.4rem;
    text-align: center;
    margin-top: 6rem;
    @media ${device.Tablet}{
      height: ${props =>props.screenH ? props.screenH - 120 : window.innerHeight - 120}px;
    }
    @media ${device.PhoneTabletLandscape} {
      padding-top: 0rem;
      margin-top: 2.5rem;
      height: ${props =>props.screenH ? props.screenH - 25 : window.innerHeight - 25}px;
    }
    @media ${device.Phone} {
      padding-top: 6rem;
      height: ${props =>props.screenH ? props.screenH - 120 : window.innerHeight - 120}px;
    }
    ` : null
  }
  ${(props) => props.fullPageDisplay ? css`
    overflow: hidden;
    height: 100%;
  ` : null
  }
`;

export const StepHeader = styled.h1`
  ${FontGraphie(2.8, 1.2, 7)}
  color: ${C.white};
  width: 95%;
  margin: auto;
  @media ${device.Tablet}, ${device.TabletLandscape}{
    margin: 1rem auto 0 ;
  }
  @media ${device.Tablet}{
    width: 80%;
  }
  @media ${device.PhoneTabletLandscape} {
    ${FontGraphie(1.8, 1.2, 7)}
    margin: 0.4rem auto 0;
  }
  @media ${device.Phone} {
      ${FontGraphie(2, 1.2, 7)}
  }
  ${(props) => DisplacementTransition({
    props: props,
    startY: props.exit ? 0 : '5rem',
    endY: props.exit ? '-5rem': 0,
    time: 0.7,
    delay: 0
  })}

  ${(props) => props.startHideTransition ? css`
    transform: translateY(-20rem);
    opacity: 0;
    transition: transform 2s ease-out 2s, opacity 2s ease-out 2s;
    ` : null
  }
`;

export const StepSubheader = styled.p`
  ${FontGraphie(1.8, 1, 5)}
  color: ${C.white};
  padding-top: 0.8rem;
  ${(props) => DisplacementTransition({
    props: props,
    startY: '8rem',
    time: 0.7,
  })}
  @media ${device.TabletLandscape}{
    ${FontGraphie(2, 1, 5)}
  }
  @media ${device.Tablet}{
    ${FontGraphie(2, 1, 5)}
  }
  @media ${device.PhoneTabletLandscape} {
    ${FontGraphie(1.2, 1, 5)}
    padding-top: 0.4rem;
  }
  @media ${device.Phone} {
    ${FontGraphie(1.4, 1, 5)}
    padding-top: 0.8rem;
  }
`;

export const Footer = styled.p`
  color: ${C.Melrose};
  ${FontGraphie(1.8, 1.2, 6)}
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 1.5rem;
  width: 100%;
  width: 80%;
  margin: 0 auto;
  ${(props) => DisplacementTransition({
    props: props,
    startY: '5rem',
    startX: '-50%',
    endX: '-50%',
    time: 0.7,
  })}

  @media ${device.TabletLandscape}{
    display: block;
    bottom: 6rem;
  }

  @media ${device.Tablet}{
    width: 65%;
    bottom: 6.5rem;
  }
  @media ${device.Phone}, ${device.PhoneTabletLandscape} {
    display: none;
  }
  ${props => props.hideFooter ? css`
    &{
      display:none
    }
    `
  : ''}

`;

export const OnboardingStepWrapper = styled.div`
  transition: all ease-in-out 0.7s;
  ${props => props.mentorMap ? css`
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    `
  : ''}
  height: 100%;
  transform: translateY(
    ${(props) => {
        if (!props.isNextStep) return (props.state === "entering" || props.state === "entered") ? '0' : '-40rem';
        return (props.state === "entering" || props.state === "entered") ? '0' : '40rem';
      }
    }
  );
  opacity: ${({state}) => state === "entering" || state === "entered" ? 1 : 0};
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
`